/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ venue: NonNullable<unknown> }} Tournament_Join_Online_BtnInputs */



/**
* | output |
* | --- |
* | "Join {venue}" |
*
* @param {Tournament_Join_Online_BtnInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_join_online_btn = /** @type {((inputs: Tournament_Join_Online_BtnInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Join_Online_BtnInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Rejoindre ${i?.venue}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Unirse a ${i?.venue}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Entrar em ${i?.venue}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Accedi a ${i?.venue}`)
	return /** @type {LocalizedString} */ (`Join ${i?.venue}`)
});